import { Controller } from '@hotwired/stimulus';

class CommentsController extends Controller {
  static targets = ['authorProfileModal'];

  static values = { selected: String };

  static classes = ['openModal', 'listItemWithNewReply'];

  connect() {}

  closeAuthorProfileModal() {
    this.authorProfileModalTarget.classList.remove(this.openModalClass);
  }

  openNewReply({ params }) {
    const listItemElement = document.getElementById(params.parentListItemId);

    if (listItemElement) {
      listItemElement.classList.add(this.listItemWithNewReplyClass);
    }
  }

  closeNewReply({ params }) {
    const turboFrameElement = document.getElementById(params.frameId);
    const listItemElement = document.getElementById(params.parentListItemId);

    if (turboFrameElement) {
      turboFrameElement.innerHTML = '';
    }
    if (listItemElement) {
      listItemElement.classList.remove(this.listItemWithNewReplyClass);
    }
  }
}

export default CommentsController;
